// Shared by the static generator and the interactive Canadian product listing.
const SHAMPOO = {
  path: '/country/canada/bath-and-body/shampoo',
  category: 'Bath & Body',
  subcategory: 'Shampoo',
  title: 'Shop Shampoo Available in Canada | OriginSelect',
  description: 'Browse shampoo available to Canadian shoppers, including shampoo bars, clarifying formulas and everyday hair care. Explore products and brand details on OriginSelect.'
};
SHAMPOO.canonical = `https://www.originselect.com${SHAMPOO.path}`;

function isShampooSelection(country, category, subcategories) {
  return country === 'canada' && category === SHAMPOO.category &&
    subcategories.length === 1 && subcategories[0] === SHAMPOO.subcategory;
}

// Remove only filters already represented by the clean path. Keep additional
// subcategories, countries, values, provinces, sorting and tracking parameters.
function cleanShampooParams(params) {
  if (params.getAll('category').length === 1 && params.get('category') === SHAMPOO.category) params.delete('category');
  for (const key of ['subcategory', 'subcategories']) {
    if (params.getAll(key).length === 1 && params.get(key) === SHAMPOO.subcategory) params.delete(key);
  }
  if (params.getAll('countries').length === 1 && params.get('countries') === 'canada') params.delete('countries');
  return params;
}
module.exports = { SHAMPOO, isShampooSelection, cleanShampooParams };
